<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    :class="getClassName"
  >
    <appPackingOptions
      v-for="(option, index) in getPackingOptions"
      :key="index"
      :propsData="option"
    >
    </appPackingOptions>
  </component>
</template>
<script>
import { usePackingOptionsStore } from "@/stores/modules/packingOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: { ...mapState(usePackingOptionsStore, ["getPackingOptions"]) },
  props: ["hideContainer"]
};
</script>
